var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Modal", { attrs: { isOpen: _vm.isOpen } }, [
    _c(
      "div",
      {
        staticClass: "ep-save-email-dialog",
        class: _vm.countryCode + "-dialog"
      },
      [
        _c("SaveAndEmailIcon"),
        _c(
          "div",
          { staticClass: "content align-self-center txt-gray w-100" },
          [
            _c("EpLabel", { staticClass: "mb-0 title txt-black" }, [
              _vm._v(
                _vm._s(
                  _vm.getTextByCountryCode(
                    _vm.countryCode,
                    "createPOPage_poCreation_successfullyPopup_text"
                  )
                ) + " Created Successfully!"
              )
            ]),
            _c("div", { staticClass: "description mb-8" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.getTextByCountryCode(
                      _vm.countryCode,
                      "createPOPage_poCreation_successfullyPopup_text"
                    )
                  ) +
                  " "
              ),
              _c(
                "span",
                {
                  staticClass: "txt-pink",
                  attrs: { "data-testid": "poNumber" }
                },
                [_vm._v(_vm._s(_vm.poNumber))]
              ),
              _vm._v(" has been created and sent to your email. ")
            ]),
            _c("div", { staticClass: "txt-gray question" }, [
              _vm._v(" Do you want to create a new one? ")
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between ep__btn_group" },
              [
                _c(
                  "EpButton",
                  {
                    staticClass: "mr-16 b-radius-5",
                    class: _vm.countryCode + "-dialog-create-button",
                    on: { click: _vm.handleCreateNewOne }
                  },
                  [_vm._v("Create a New One")]
                ),
                _c(
                  "EpButton",
                  {
                    staticClass: "ml-16 b-radius-5 ep__btn_details",
                    class: _vm.countryCode + "-dialog-view-button",
                    attrs: { variant: "outlined", color: "secondary" },
                    on: { click: _vm.handleViewDetails }
                  },
                  [_vm._v("View Details")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }